/* eslint-disable */
import { Controller } from '@hotwired/stimulus';
import {
  sendTrackingEvent,
  trackCompleteEvent,
  findCategoryByElement } from 'components/analytics/conversions/tracking';
import {
  EXPLORE_CLICK,
  LOGIN_CLICK,
  JOIN_CLICK,
  JOIN_PRO_CLICK,
  JOIN_PRO_COMPLETE,
  REBUY_CLICK
} from 'components/analytics/conversions/constants/actions';
import { featureEnabled } from 'lib/helpers';
import MediaMatcher from 'lib/media-matcher';

const mediaMatcher = new MediaMatcher();

export default class SiteHeaderController extends Controller {
  static targets = [
    'menuGroup',
    'menuGroupStatic',
    'subMenu',
    'mobileMenu',
    'mainUserMenu',
    'loginButton',
    'signupButton',
  ];

  prependIds = [
    'menu-group-join-pro',
  ];

  connect() {
    if (this.hasMobileMenuTarget) {
      this.setupMenuGroupParents();

      this.setupSiteNavigationMediaQueries();

      mediaMatcher.evaluateAll();
      mediaMatcher.addListeners();
    }
  }

  disconnect() {
    mediaMatcher.removeListeners();
    mediaMatcher.clearQueries();
  }

  toggleMobileMenuScrollClasses = (event) => {
    if(event.currentTarget.parentNode.classList.contains('is-closed')) {
      document.querySelector('body').classList.remove('has-open-mobile-menu', 'has-active-mobile-submenu');
    } else {
      document.querySelector('body').classList.add('has-open-mobile-menu');
    }
  }

  createOverlay(action) {
    const overlay = document.createElement('DIV');

    overlay.classList.add('ez-dark-overlay');
    overlay.classList.add('mobile-search-overlay');
    overlay.dataset.action = action;

    this.element.appendChild(overlay);
  }

  clearSearchInput() {
    const searchInput = this.element.querySelector('#search');

    searchInput.value = '';
    searchInput.focus();
  }

  toggleMobileSearch() {
    const searchInput = document.getElementById('search');
    const bodyEl = document.querySelector('body');
    const overlayEl = document.querySelector('.ez-dark-overlay.mobile-search-overlay');
    
    bodyEl.classList.toggle('is-mobile-search');
    
    if (bodyEl.classList.contains('is-mobile-search') && !overlayEl) {
      this.savedVal = searchInput.value;

      this.createOverlay('click->site-header#toggleMobileSearch');

      searchInput.focus();

      // This makes sure the cursor goes at the end
      searchInput.value = '';
      searchInput.value = this.savedVal;
    } else if (!bodyEl.classList.contains('is-mobile-search') && overlayEl) {
      overlayEl.remove();

      searchInput.value = this.savedVal;
    }
  }

  setupSiteNavigationMediaQueries() {
    const bodyClass = document.querySelector('body').classList;

    if (bodyClass.contains('is-logged-in') && bodyClass.contains('is-pro')) {
      this.setupProUserMediaQueries();
    } else if (bodyClass.contains('is-logged-in')) {
      this.setupLoggedInMediaQueries();
    } else {
      this.setupLoggedOutMediaQueries();
    }

    this.setupSearchCloseQueries();
  }

  setupSearchCloseQueries() {
    mediaMatcher.addMediaQuery('(max-width: 635px)',
      null,
      () => {     
        const overlayEl = document.querySelector('.ez-dark-overlay.mobile-search-overlay');

        if (overlayEl) this.toggleMobileSearch();
      }
    );
  }

  setupProUserMediaQueries() {
    mediaMatcher.addMediaQuery('(max-width: 940px)',
      () => { this.collectAllMenuGroups(); },
      () => { if (this.mobileMenuItems()) this.restoreAllMenuGroups(); }
    );
  }

  setupLoggedInMediaQueries() {
    mediaMatcher.addMediaQuery('(min-width: 1181px)',
      () => { this.restoreAllMenuGroups(); }
    );

    mediaMatcher.addMediaQuery('(max-width: 1180px) and (min-width: 941px)',
      () => {
        this.restoreAllMenuGroups();

        if (!featureEnabled('header-and-search-optimizations')) {
          this.collectJoinBtn();
        }
      }
    );

    mediaMatcher.addMediaQuery('(max-width: 940px)',
      () => {
        this.collectAllMenuGroups();

        if (!featureEnabled('header-and-search-optimizations')) {
          this.collectJoinBtn();
        }
      }
    );
  }

  setupLoggedOutMediaQueries() {
    mediaMatcher.addMediaQuery('(max-width: 1105px)',
      () => {
        this.collectAllMenuGroups();

        if (!featureEnabled('header-and-search-optimizations')) {
          this.collectJoinBtn('menu-group-browse');
        }
      },
      () => {
        if (this.mobileMenuItems()) this.restoreAllMenuGroups();

        if (!featureEnabled('header-and-search-optimizations')) {
          this.collectJoinBtn('menu-group-auth');
        }
      }
    );
  }

  setupMenuGroupParents() {
    this.menuGroupTargets.forEach((menuGroup) => {
      const parentMenu = menuGroup.closest('.ez-site-header__submenu-wrapper');

      if (!menuGroup.dataset.parentMenu) menuGroup.dataset.parentMenu = parentMenu.id;
    })
  }

  moveStaticMenuGroups(destination) {
    if (!featureEnabled('header-and-search-optimizations')) {
      this.menuGroupStaticTargets.forEach((menuGroup) => {
        destination.appendChild(menuGroup);
      });
    }
  }

  collectJoinBtn(altDest) {
    if (!document.querySelector('#menu-group-join-pro')) return;

    const destinationId = altDest || 'menu-group-user';
    const destination = document.querySelector(`#${destinationId}`);

    destination.insertBefore(
      document.querySelector('#menu-group-join-pro'),
      destination.childNodes[0]
    );
  }

  collectMenuGroup(menuGroup, destination) {
    if (!menuGroup) return false;

    const parentMenu = menuGroup.closest('.ez-site-header__submenu-wrapper');

    parentMenu.classList.add('is-hidden');

    this.prependIds.includes(menuGroup.id)
      ? destination.insertBefore(menuGroup, destination.childNodes[0])
      : destination.appendChild(menuGroup);

    if(featureEnabled('header-and-search-optimizations') && this.isJoinButtonGroup(menuGroup)) {
      const joinBtn = menuGroup.querySelector('a.ez-site-header__menu-item');

      this.dressUpJoinButton(joinBtn);
    }
  }

  collectAllMenuGroups() {
    this.moveStaticMenuGroups(this.mobileMenuTarget);

    if (featureEnabled('header-and-search-optimizations')) {
      this.menuGroupTargets.forEach((menuGroup) => {
        if (!this.isStaticMenuGroup(menuGroup)) {
          this.collectMenuGroup(menuGroup, this.mobileMenuTarget);
        }
      })
    } else {
      this.menuGroupTargets.forEach((menuGroup) => {
        if (!this.isStaticMenuGroup(menuGroup) && !this.isJoinButtonGroup(menuGroup)) {
          this.collectMenuGroup(menuGroup, this.mobileMenuTarget);
        }
      })
    }
  }

  restoreMenuGroup(menuGroup, destination) {
    const parentMenu = destination.closest('.ez-site-header__submenu-wrapper');

    parentMenu.classList.remove('is-hidden');

    this.prependIds.includes(menuGroup.id)
      ? destination.insertBefore(menuGroup, destination.childNodes[0])
      : destination.appendChild(menuGroup);

    if(featureEnabled('header-and-search-optimizations') && this.isJoinButtonGroup(menuGroup)) {
      const joinBtn = menuGroup.querySelector('a.ez-btn--light');

      this.dressDownJoinButton(joinBtn);
    }  
  }

  restoreAllMenuGroups() {
    if (this.hasMainUserMenuTarget) this.moveStaticMenuGroups(this.mainUserMenuTarget);

    this.menuGroupTargets.forEach((menuGroup) => {
      if (!this.isStaticMenuGroup(menuGroup)) {
        const parentMenu = document.querySelector(`#${menuGroup.dataset.parentMenu}`);
        const parentSubMenu = parentMenu.querySelector('.ez-drop-down__submenu');

        const destination = parentSubMenu ? parentSubMenu : parentMenu;

        this.restoreMenuGroup(menuGroup, destination);
      }
    });
  }

  isJoinButtonGroup(menuGroup) {
    return menuGroup.id === 'menu-group-join-pro';
  }

  dressUpJoinButton(joinBtn) {
    if (joinBtn && !this.isSalesEventJoinBtn(joinBtn)) {
      joinBtn.classList.add('ez-btn', 'ez-btn--light', 'ez-btn--medium');
      joinBtn.classList.remove('ez-site-header__menu-item');
    }
  }

  dressDownJoinButton(joinBtn) {
    if (joinBtn && !this.isSalesEventJoinBtn(joinBtn)) {
      joinBtn.classList.remove('ez-btn', 'ez-btn--light', 'ez-btn--medium');
      joinBtn.classList.add('ez-site-header__menu-item');
    }
  }

  isSalesEventJoinBtn(joinBtn) {
    return joinBtn.classList.contains('ez-site-header__menu-item--sales-event');
  }

  isStaticMenuGroup(menuGroup) {
    return menuGroup.dataset.siteHeaderTarget.indexOf('menuGroupStatic') > -1;
  }

  mobileMenuItems() {
    const dropdowns = this.mobileMenuTarget.querySelector('#mobile-menu .ez-drop-down__submenu-group')
    const groups = this.mobileMenuTarget.querySelector('#mobile-menu .ez-site-header__submenu-group')
    return dropdowns || groups;
  }

  buyMoreClick(event) {
    const category = findCategoryByElement(event.target);

    sendTrackingEvent({
      element: event.target,
      data: { action: JOIN_PRO_CLICK, category }
    });

    trackCompleteEvent({
      action: JOIN_PRO_COMPLETE,
      category
    });
  }

  rebuyCredits(event) {
    sendTrackingEvent({
      element: event.currentTarget,
      data: { action: REBUY_CLICK }
    });
  }

  headerLogin() {
    sendTrackingEvent({
      element: this.loginButtonTarget,
      data: { action: LOGIN_CLICK },
    });
  }

  headerSignUp() {
    sendTrackingEvent({
      element: this.signupButtonTarget,
      data: { action: JOIN_CLICK }
    });
  }

  trackExploreClick = (event) => {
    sendTrackingEvent({
      element: event.target,
      data: {
        action: EXPLORE_CLICK,
        label: `Link-${event.target.dataset.englishLabel}`,
        content_type: `Content-${event.target.dataset.contentType}`,
      },
    });
  }

  sendHeaderJoinProEvent(event) {
    const category = findCategoryByElement(event.target);

    sendTrackingEvent({
      element: event.target,
      data: { action: JOIN_PRO_CLICK, category }
    });

    trackCompleteEvent({
      action: JOIN_PRO_COMPLETE,
      category
    });
  }
}
